import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";
import { AppErrorBoundary } from "@/components/ui/error-boundary";

const ReportsView = lazy(async () => {
  const m = await import("@/features/reports/components/reports-view");
  return { default: m.ReportsView };
});

function ReportsPage() {
  return (
    <AppErrorBoundary region label="reports">
      <Suspense fallback={null}>
        <ReportsView />
      </Suspense>
    </AppErrorBoundary>
  );
}

export const reportsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/reports",
  component: ReportsPage,
});
